export const MODULE_STORE = 'Sklad';
export const DMS_MODULE = 'Sklad';
export const NAME = 'Sklad';
export const MODULE_API = 'Nd';
export const API_ND_AREA = 'Nd';
export const API_ND_SKLAD = 'NdSklad';
export const PARTS_INVENTORY_ADJUSTMENTS = 'PartsInventoryAdjustments';
export const BULK_INVENTORY_ADJUSTMENT_APPROVAL = 'BulkInventoryApproval';
export const BulkInventoryAdjusments = 'BulkInventoryAdjustments';
export enum PART_RETURN_REQUEST_STATUS {
	RAISE = 1,
	APPROVE = 2,
	REJECT = 3,
	DISABLE = 4,
	CLOSE = 6
}

export enum REPORT_FILE_TYPE {
	PDF = 1
}
